import { Fragment, useState } from "react";
import { menuRoutes } from "../../../router/menu";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import GeneratorCustomReport from "../components/GeneratorCustomReport";
import useFilters from "../../../hooks/useFilters";
import ReportList from "./ReportList";


const ReportListWrapper = () => {

    // STATES

    const [isOpen, setIsOpen] = useState(false);
    const [ doRefresh, setDoRefresh ] = useState(false);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de Informes' },
        { name: 'Informes', href: menuRoutes.reports.path },
    ];
    
    // HOOKS

    const { userCan } = usePrivilege();

    // RENDER
    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Informes" breadcrumb={breadCrumb}>
                </PageHeader>
                {
                    userCan('generate_reports', 'document') &&
                    (
                        <GeneratorCustomReport doRefresh={doRefresh} setDoRefresh={setDoRefresh}  />
                    )
                }
                {
                    userCan('list_reports', 'document') &&
                    (
                        <ReportList doRefresh={doRefresh} setDoRefresh={setDoRefresh} setIsOpen={setIsOpen} isOpen={isOpen} />
                    )
                }
               

            </FiltersProvider>
        </Fragment>

    )


}

export default ReportListWrapper;
